import React from 'react';
import { Route, useParams } from 'react-router';
import { Redirect, Switch } from 'react-router-dom';
import { userHasWarrantyEnabledRedir } from '../core/auth';
import { useFeatureFlag, useFbClient } from '../core/hooks/useFeatureFlag';
import { getFeatBitConfig } from '../core/config';
import ClaimDetail from '../views/reclamationsOld/containers/ClaimDetail';
import ClaimsViews from '../views/reclamationsOld/components/ClaimsViews';
import ClaimReports from '../views/reclamationsOld/containers/ClaimReports';
import Claims from '../views/reclamationsOld/containers/Claims';
import ClaimAddedConfirmation from '../views/reclamationsOld/components/ClaimAddedConfirmation';
import ReclamationEdit from '../views/reclamationsOld/containers/ReclamationEdit';
import ReclamationFormWrapper from '../views/reclamationsOld/containers/ReclamationFormWrapper';
import DamageOptions from '../views/reclamationsOld/containers/DamageOptions';

const { sdkKey } = getFeatBitConfig();
const isFeatBitConfigured = Boolean(sdkKey);

const ClaimsOldRoute = () => {
  const { site } = useParams();
  const fbClient = useFbClient();
  const claimsOldEnabled = useFeatureFlag('claims-old', true);

  if (isFeatBitConfigured && !fbClient) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading...</div>;
  }

  if (!claimsOldEnabled) {
    return <Redirect to={`/${site}/claims`} />;
  }

  return (
    <ClaimsViews>
      <Switch>
        <Route exact path="/:site/claims-old">
          <Claims />
        </Route>
        <Route exact path="/:site/claims-old/reports">
          <ClaimReports />
        </Route>
        <Route exact path="/:site/claims-old/damage-options">
          <DamageOptions />
        </Route>
        <Route path="/:site/claims-old/create">
          <ReclamationFormWrapper />
        </Route>
        <Route path="/:site/claims-old/:reclamation/edit">
          <ReclamationEdit />
        </Route>
        <Route path="/:site/claims-old/:reclamation/complete">
          <ReclamationEdit />
        </Route>
        <Route path="/:site/claims-old/:claim/success">
          <ClaimAddedConfirmation />
        </Route>
        <Route path="/:site/claims-old/:claim">
          <ClaimDetail />
        </Route>
      </Switch>
    </ClaimsViews>
  );
};

export default userHasWarrantyEnabledRedir(ClaimsOldRoute);
